import * as Sentry from '@sentry/react';

type BreadcrumbCategory =
  | 'bot.action'
  | 'system.action'
  | 'auth'
  | 'navigation'
  | 'exchange.action';

export function addBreadcrumb(
  category: BreadcrumbCategory,
  message: string,
  data?: Record<string, unknown>,
) {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
    level: 'info',
  });
}
